import { render } from "./TemplateDemandIndex.vue?vue&type=template&id=359f6d80"
import script from "./TemplateDemandIndex.vue?vue&type=script&lang=js"
export * from "./TemplateDemandIndex.vue?vue&type=script&lang=js"
script.render = render

export default script